export default __webpack_public_path__ + "static/11_Dog-9074b208472703afa26672515b53f49e.png";